export const calculateBaseCount = () => {
    const baseDate = new Date('2024-01-01');
    const now = new Date();
    const diffTime = Math.abs(now - baseDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.floor(125000 + (diffDays * 847));
};